import React from 'react';
import './Program.css';

const Program = () => {
  const features = [
    'BSc Aeronautics from Embry-Riddle Aeronautical University',
    'FAA Commercial Pilot License (CPL)',
    'Certified Flight Instructor (CFI, CFII) Ratings',
    'Airline Transport Pilot (ATP) Certification',
    '4000+ Flight Hours Experience',
    'Assured Job Placement in USA'
  ];

  const handleApplyClick = () => {
    const applicationSection = document.getElementById('apply');
    if (applicationSection) {
      applicationSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="program" id="program">
      <div className="container">
        <div className="program-content">
          <div className="program-features">
            <h3 className="section-header">THE PROGRAM</h3>
            <h2 className="section-title">
              LEARN & EARN <span className="title-highlight">PROGRAM</span>
            </h2>
            <p className="section-description">
              A unique Professional Pilot Training package offered exclusively through Aviator1903 in collaboration with Worldwide Wings LLC. Get your CPL and CFI license in the first year, then build experience as a flight instructor while earning handsomely.
            </p>
            
            <div className="features-list">
              {features.map((feature, index) => (
                <div className="feature-item" key={index}>
                  <div className="feature-check-circle">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M11.6666 3.5L5.24992 9.91667L2.33325 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
            
            <button onClick={handleApplyClick} className="btn btn-program">
              Apply for This Program
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3.33325 8H12.6666M12.6666 8L7.99992 3.33333M12.6666 8L7.99992 12.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
          
          <div className="program-image">
            <img 
              src="/images/pilot-training.jpg" 
              alt="Pilot Training" 
              onError={(e) => e.target.src = 'https://via.placeholder.com/560x480/1e3a8a/ffffff?text=Pilot+Training'}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Program;
